(async function handleIpRedirect() {
    const LOCAL_STORAGE_KEY = 'boa-geolocation';
    const TAIWAN_REDIRECT_URL = 'https://www.laline.com.tw/en/';
    const ACTIONS = {
        REDIRECT_TW: 'redirect-tw',
        STAY: 'stay',
    };
    // See if this device has already been checked
    const previousGeolocationCheck = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (previousGeolocationCheck === ACTIONS.REDIRECT_TW) {
        window.location.href = TAIWAN_REDIRECT_URL;
        return;
    }
    if (previousGeolocationCheck === ACTIONS.STAY) {
        document.body.style.visibility = 'visible';
        return;
    }
    // This is the first time this device is being checked
    const TAIWAN_COUNTRY_CODE = 'TW';
    try {
        const ipResponse = await fetch('https://api.ipify.org?format=json');
        const { ip } = await ipResponse.json();
        const geolocationRequest = await fetch(`https://ipapi.co/${ip}/json/`);
        const { country_code: countryCode } = await geolocationRequest.json();

        if (countryCode && countryCode.toUpperCase() === TAIWAN_COUNTRY_CODE && !Shopify.designMode) {
            localStorage.setItem(LOCAL_STORAGE_KEY, ACTIONS.REDIRECT_TW);
            window.location.href = TAIWAN_REDIRECT_URL;
        } else {
            localStorage.setItem(LOCAL_STORAGE_KEY, ACTIONS.STAY);
            document.body.style.visibility = 'visible';
        }
    } catch (error) {
        // If the geolocation lookup fails, don't trap the user on a hidden page
        document.body.style.visibility = 'visible';
    }
})();
